import React from "react";
import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  titulo: {
    fontSize: 24,
    textAlign: "left",
    color: theme.palette.primary.main,
    margin: "5px 0 20px 0",
    fontWeight: "normal",
  },
}));

interface OwnProps {
  children: React.ReactNode;
}

type Props = OwnProps;

const Titulo: React.FC<Props> = ({ children }) => {
  const classes = useStyles();
  return <h2 className={classes.titulo}>{children}</h2>;
};

export default Titulo as React.ComponentType<Props>;
